export interface LiveUnitMetaLanding {
    accessArchives: boolean;
    accessStream: boolean;
    cameraList: CameraInformation[];
    clientId: number;
    clientName: string | null;
    liveUnitId: number;
    liveUnitName: string;
    liveUnitSerial: string | null;
    locationCity: string | null;
    locationId: number;
    locationName: string;
    locationState: string | null;
    locationStreet: string | null;
    locationZip: string | null;
    unitHealth: UnitHealth | null;
}

export interface LiveUnitInfo {
    clientId: number;
    clientName: string | null;
    liveUnitId: number;
    liveUnitName: string;
    locationId: number;
    locationName: string;
    showClientNameStreamPage: boolean;
    showClientNameHistoryPage: boolean;
    liveUnitSerialNum: string | null;
}

export interface CameraInformation {
    id: number;
    name: string | null;
    thumbnailPreset: number | null;
}

export interface UnitHealth {
    color: string;
    isFlapping: boolean;
    isGradient: boolean;
    overlay: string | null;
    startColor: string;
    statusText: string;
}

export enum UnitType {
    ArchiveCabinet = "Archive Cabinet",
    Deactivated = "Deactivated",
    LiveUnit = "Live Unit",
}
